<template>
    <div>
        <b-btn v-b-modal.inspiration size="sm" variant="link" class="color-blue">
            <!-- <span v-if="type == 'choose-your-design'">Choose from template</span> -->
            <!-- <span v-else>Inspiration Board</span> -->
            <span>Inspire Me</span>
            <i id="pencil" class="fa fa-pencil fa-lg animated jello" aria-hidden="true"></i>
        </b-btn>
        <b-modal id="inspiration" ref="inspiration" size="lg" hide-header hide-footer>
            <inspiration :type="type" :selected="selected" class="mt-4"></inspiration>
            <button ref="modalClose" type="button" class="btn modal-close" @click="close">
                <i class="fa fa-times fa-lg" aria-hidden="true"></i>
            </button>
        </b-modal>
    </div>
</template>

<script>
import Inspiration from '../../pages/inspiration/inspiration';

$.fn.extend({
    animateCss: function (animationName, onEnd) {
        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        this.addClass('animated ' + animationName).one(animationEnd, function() {
            $(this).removeClass('animated ' + animationName);
            onEnd();
        });
        return this;
    }
});

export default {
    name: 'inspiration-modal',
    components: { Inspiration },
    props: {
        type: { default: 'inspiration', type: String },
        selected: { default: null }
    },
    methods: {
        close() {
            this.$root.$emit('bv::hide::modal','inspiration')
        },
        animate() {
            let that = this;
            $('#pencil').animateCss('jello', () => {
                setTimeout(() => { that.animate() }, 2000);
            });
        }
    },
    mounted() {
        this.animate()
    }
}
</script>

<style lang="scss" scoped>
#pencil {
    animation-duration: 2s;
    animation-delay: 2s;
    // animation-iteration-count: 3;
}
</style>





// WEBPACK FOOTER //
// src/components/modules/inspiration-modal/inspiration-modal.vue